module.exports = __webpack_public_path__ + "img/c1.a5c463f4.jpg";